/** @jsxImportSource @emotion/react */
import { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { HelmetProvider } from 'react-helmet-async';
import GlobalProvider from 'context/GlobalProvider';

import styled from '@emotion/styled';

import AppErrorBoundary from 'components/ErrorBoundary';
import RouteToTop from 'components/layout/RouteToTop';

import Home from 'pages/Home';
import Login from 'pages/Login';
import { Checkout, Admin } from 'pages/lazyRoutes';
import NotFound from 'pages/NotFound';
import theme from 'styles/theme';
import { MENU_DEEP_LINKS } from 'config/menuDeepLinks';
import ProtectedRoute from 'components/ProtectedRoute';
import LoadingOverlay from 'components/ui/LoadingOverlay';

const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
`;

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppErrorBoundary>
        <HelmetProvider>
          <GlobalProvider>
            <Router future={{ v7_startTransition: true }}>
              <RouteToTop />
              <StyledApp>
                <Suspense fallback={<LoadingOverlay />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    {/* Short marketing/QR URLs (e.g. /liquor) that render the
                      homepage but land on the menu with one category already
                      selected. An allowlist, so unlisted paths still 404. */}
                    {Object.values(MENU_DEEP_LINKS).map((deepLink) => (
                      <Route
                        key={deepLink.path}
                        path={deepLink.path}
                        element={<Home deepLink={deepLink} />}
                      />
                    ))}
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute>
                          <Admin />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </StyledApp>
            </Router>
          </GlobalProvider>
        </HelmetProvider>
      </AppErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
